import React from "react";
import { Badge } from "..";

function StatusIndicator({ status, label }) {
	if (status === "approved") {
		return <Badge variant="success">{label || "Approved"}</Badge>;
	}
	if (status === "denied") {
		return <Badge variant="danger">{label || "Denied"}</Badge>;
	}
	if (status === "pending") {
		return <Badge variant="warning">{label || "Pending"}</Badge>;
	}
	if (label) {
		return <Badge>{label}</Badge>;
	}
	return null;
}

export default StatusIndicator;
